













import { Component, Prop, Vue } from 'vue-property-decorator';
import Application from "@/consoleapi/api/applications";

@Component
export default class Sidebar extends Vue {
  @Prop() private select!: string;

  @Prop() userId!: string;

  public applications = [];

  public accountId = Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID));

  public bearer = Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN));

  getApplications() {
    const applications = new Application();
    applications.setBearerToken(this.bearer);
    return applications.get(this.accountId)
        .then(response => {
          //console.log(response.data);
          this.applications = response.data;
        });
  }

  mounted(){
    this.getApplications();
  }
}
